module.exports = __webpack_public_path__ + "static/media/sample3.cac6fa58.png";